(() => {
  if (window.__phFeaturedCollectionTabsBound) return;

  window.__phFeaturedCollectionTabsBound = true;

  const sectionSelector = '.featured-collection-tabs';
  const tabSelector = '.tab-btn';

  function moveTabToStart(tab, scrollContainer) {
    if (!tab || !scrollContainer) return;

    const maxScroll =
      scrollContainer.scrollWidth - scrollContainer.clientWidth;

    if (maxScroll <= 1) return;

    const tabRect = tab.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const edgePadding = 8;

    const isFullyVisible =
      tabRect.left >= containerRect.left + edgePadding &&
      tabRect.right <= containerRect.right - edgePadding;

    if (isFullyVisible) return;

    const delta =
      tabRect.left -
      containerRect.left -
      edgePadding;

    const targetScroll = Math.min(
      Math.max(scrollContainer.scrollLeft + delta, 0),
      maxScroll
    );

    scrollContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  function observeSection(container) {
    if (!container || container.dataset.fadeInitialized === 'true') return;

    container.dataset.fadeInitialized = 'true';

    if (!('IntersectionObserver' in window)) {
      container.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.1
      }
    );

    observer.observe(container);
  }

  function initializeSections(root = document) {
    if (root instanceof Element && root.matches(sectionSelector)) {
      observeSection(root);
    }

    root.querySelectorAll(sectionSelector).forEach(observeSection);
  }

  function activateTab(tab) {
    const container = tab.closest(sectionSelector);

    if (!container) return;

    const scrollContainer = tab.closest('.tabs-wrapper');

    if (tab.classList.contains('active')) {
      moveTabToStart(tab, scrollContainer);
      return;
    }

    const targetId = tab.dataset.tab;

    const targetContent = container.querySelector(
      `[id="${targetId}"]`
    );

    if (!targetContent) return;

    const tabs = container.querySelectorAll(tabSelector);
    const contents = container.querySelectorAll('.tab-content');

    tabs.forEach((item) => {
      item.classList.remove('active');
      item.setAttribute('aria-selected', 'false');
      item.setAttribute('tabindex', '-1');
    });

    contents.forEach((content) => {
      content.classList.remove('is-active');
      content.setAttribute('hidden', '');
    });

    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    tab.removeAttribute('tabindex');

    targetContent.classList.add('is-active');
    targetContent.removeAttribute('hidden');

    const slider = targetContent.querySelector('carousel-slider');

    if (slider && typeof slider.init === 'function') {
      slider.init();
    }

    window.dispatchEvent(new Event('resize'));

    moveTabToStart(tab, scrollContainer);
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(tabSelector);

    if (!tab || !tab.closest(sectionSelector)) return;

    activateTab(tab);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeSections(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeSections();
      },
      { once: true }
    );
  } else {
    initializeSections();
  }
})();